// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-height-wrapper-module__full-height-wrapper--scrollable___yGIkW {
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/components/layouts/full-height-wrapper/full-height-wrapper.module.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ","sourcesContent":[".full-height-wrapper {\n  &--scrollable {\n    overflow-y: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"full-height-wrapper--scrollable": `full-height-wrapper-module__full-height-wrapper--scrollable___yGIkW`
};
export default ___CSS_LOADER_EXPORT___;
